import { Link } from 'react-router-dom'

export function TrustMetrics() {
  return (
    <div className="p-6 space-y-6">
      <div>
        <Link
          to="/trust"
          className="inline-flex items-center gap-1 text-sm text-[#7f4f9a] dark:text-[#b58fcc] hover:underline"
        >
          ← Back to queue
        </Link>
      </div>

      <div>
        <div className="text-xs font-semibold uppercase tracking-wider text-[#7f4f9a] dark:text-[#b58fcc]">
          Sentinel
        </div>
        <h1 className="font-heading text-2xl font-bold text-gray-900 dark:text-gray-100 mt-1">
          Pipeline Metrics
        </h1>
        <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">
          Health and accuracy signals from the trust pipeline.
        </p>
      </div>

      <div className="rounded-2xl border border-dashed border-[#ecdefc] dark:border-[#3d2c4f] bg-white dark:bg-[#1a1520] p-10 text-center">
        <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-[#f5edff] dark:bg-[#2a1f3d] mb-4">
          <svg
            className="w-7 h-7 text-[#7f4f9a] dark:text-[#b58fcc]"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={1.5}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M3 13.125C3 12.504 3.504 12 4.125 12h2.25c.621 0 1.125.504 1.125 1.125v6.75C7.5 20.496 6.996 21 6.375 21h-2.25A1.125 1.125 0 013 19.875v-6.75zM9.75 8.625c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125v11.25c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 01-1.125-1.125V8.625zM16.5 4.125c0-.621.504-1.125 1.125-1.125h2.25C20.496 3 21 3.504 21 4.125v15.75c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 01-1.125-1.125V4.125z"
            />
          </svg>
        </div>
        <p className="text-base font-semibold text-gray-800 dark:text-gray-100">
          Coming soon
        </p>
        <p className="mt-1 text-sm text-gray-500 dark:text-gray-400 max-w-md mx-auto">
          Block-rate, override rate, L3 escalation, and latency dashboards are
          on the way once the backend metrics endpoint is wired up.
        </p>
      </div>
    </div>
  )
}
